import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "crm:px-4 crm:py-2 crm:border-b" }
const _hoisted_2 = { class: "crm:flex crm:justify-between crm:items-center" }
const _hoisted_3 = { class: "crm:text-dark crm:flex-1 crm:flex crm:flex-col" }
const _hoisted_4 = { class: "crm:font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "crm:flex-1"
}
const _hoisted_6 = {
  key: 1,
  class: "crm:flex-1"
}
const _hoisted_7 = {
  key: 2,
  class: "crm:opacity-60"
}
const _hoisted_8 = {
  key: 0,
  class: "crm:flex-1"
}
const _hoisted_9 = { class: "crm:flex-1" }


export default {
  __name: 'AppProperties',
  props: {
  item: Object
},
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.item.name), 1 /* TEXT */),
        (__props.item.type)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("i", null, _toDisplayString(__props.item.type.name), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        (__props.item['defaultValue'] !== undefined)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Default: " + _toDisplayString(__props.item.defaultValue.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (__props.item.tags && __props.item.tags['deprecated'] !== undefined)
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, " @deprecated: " + _toDisplayString(__props.item.tags.deprecated[0].description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      (__props.item['values'] !== undefined)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.item.values), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_9, _toDisplayString(__props.item.description), 1 /* TEXT */)
    ])
  ]))
}
}

}